import { Box, SxProps, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import { FormValues } from '../types';
import { Input } from 'components/Inputs';
import { useEffect } from 'react';
import { AutomationActionType } from 'services/automation/types';

const container: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: 1
};

type Props = {
  formik: FormikProps<FormValues>;
  index: number;
};

export const UploadDocumentItem: React.FC<Props> = ({ formik, index }) => {
  useEffect(() => {
    formik.setFieldValue(
      `[${index}].action.type`,
      AutomationActionType.SEND_DOCUMENT_VIA_EMAIL
    );
  }, []);

  return (
    <Box sx={container}>
      <Typography>and is validated then send to email</Typography>

      <Box mb={0.8}>
        <Input
          value={formik.values[index].action.recipientEmailAddress || ''}
          onChange={formik.handleChange}
          name={`[${index}].action.recipientEmailAddress`}
          id={`[${index}].action.recipientEmailAddress`}
          onBlur={formik.handleBlur}
          error={Boolean(
            formik.touched[index] &&
              formik.errors[index]?.action?.recipientEmailAddress
          )}
          helperText={
            formik.touched[index] &&
            formik.errors[index]?.action?.recipientEmailAddress
          }
          type="email"
        />
      </Box>
    </Box>
  );
};
